import { useParams } from 'react-router-dom';
import AdminSectionTitle from '../components/AdminSectionTitle';
import RequireAuth from '../store/utils/RequireAuth';
import ListValidatorContent from '../components/ListValidatorContent';

const EventListValidator = () => {
  const { list_id: listId } = useParams();

  return (
    <RequireAuth>
      <div className='my-6 flex flex-col gap-6 min-h-screen'>
        <AdminSectionTitle
          title='Listas'
        />
        <ListValidatorContent
          listId={listId || ''}
        />
      </div>
    </RequireAuth>
  );
};

export default EventListValidator;
